var Block;
(function (Block) {
  Block["DOCUMENT"] = "doc";
  Block["HEADING"] = "heading";
  Block["PARAGRAPH"] = "paragraph";
  Block["QUOTE"] = "blockquote";
  Block["OL_LIST"] = "ordered_list";
  Block["UL_LIST"] = "bullet_list";
  Block["LIST_ITEM"] = "list_item";
  Block["CODE"] = "code_block";
  Block["HR"] = "horizontal_rule";
  Block["BR"] = "hard_break";
  Block["IMAGE"] = "image";
})(Block || (Block = {}));
var Mark;
(function (Mark) {
  Mark["BOLD"] = "bold";
  Mark["STRONG"] = "strong";
  Mark["STRIKE"] = "strike";
  Mark["UNDERLINE"] = "underline";
  Mark["ITALIC"] = "italic";
  Mark["CODE"] = "code";
  Mark["LINK"] = "link";
  Mark["STYLED"] = "styled";
})(Mark || (Mark = {}));
var ComponentType = 'blok';
var TextType = 'text';
export { Block, ComponentType, Mark, TextType };